import {useTheme} from 'styled-components';

import {TextContainer, Wrapper} from './styled';
import {CircleQuestionMarkIcon} from 'lucide-react';
import {cn} from '@chekin/guestapp-ui-kit';
import {useMemo} from 'react';

type QuestionMarkAndTextProps = {
  onClick: () => void;
  text?: string;
  iconSize?: number | string;
  className?: string;
};

function QuestionMarkAndText({
  onClick,
  text,
  iconSize = 16,
  className,
}: QuestionMarkAndTextProps) {
  const theme = useTheme();
  const iconSizeClass = useMemo(() => {
    const internalSize = iconSize || 16;
    return `w-[${internalSize}px] h-[${internalSize}px]`;
  }, [iconSize]);

  return (
    <Wrapper
      onClick={onClick}
      className={cn(className, 'question-mark-text', 'kiosko:gap-4')}
    >
      <CircleQuestionMarkIcon
        className={cn(iconSizeClass, 'kiosko:w-10 kiosko:h-10')}
        color={theme.colors.buttons.textButton}
      />
      <TextContainer className="kiosko:text-kiosko-s">{text ?? ''}</TextContainer>
    </Wrapper>
  );
}

export {QuestionMarkAndText};
